import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {NotificationManager} from '../../../../components/common/react-notifications';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import ModalManager from '../../../../components/modal/ModalManager';
import UserGroupForm from '../../../../containers/UserGroupForm';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {reactTableText} from '../../../../constants/configs';
import ToolTip from '../../../../components/ToolTip';
import Rbac from '../../../../components/Rbac';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import {keyBy} from'lodash';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      kycPolicies: null,
      loyaltyPolicies: null,
      loading: true,
    };
  }

  fetchData = async () => {
    try {
      await Promise.all([
        this.fetchUserGroups(),
        this.fetchKycPolicies(),
        this.fetchLoyaltyPolicies(),
      ]);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({loading: false});
    }
  };

  fetchUserGroups = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/user-groups', null, {
        params: {limit: 100}
      });
      this.setState({
        groups: data.userGroups,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchKycPolicies = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/kyc-policies');
      this.setState({
        kycPolicies: keyBy(data.policies, 'id'),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchLoyaltyPolicies = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/loyalty-policies');
      this.setState({
        loyaltyPolicies: keyBy(data.policies, 'id'),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  deleteGroup = async id => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'DELETE',
        '/admin-ui/user-groups',
        null,
        {params: {id, }}
      );
      NotificationManager.success(t('User Group deleted successfully'), t('Message'));
      await this.fetchUserGroups();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    const {t} = this.props;
    const {kycPolicies, loyaltyPolicies} = this.state;
    ModalManager.open({
      isOpen: true,
      title: t('Create User Group'),
      body: <UserGroupForm
        kycPolicies={kycPolicies}
        loyaltyPolicies={loyaltyPolicies}
        fireFetchData={this.fetchUserGroups}
      />
    });
  };

  onPressEdit = userGroup => {
    const {t} = this.props;
    const {kycPolicies, loyaltyPolicies} = this.state;
    ModalManager.open({
      isOpen: true,
      title: t('Edit User Group'),
      body: <UserGroupForm
        userGroup={userGroup}
        kycPolicies={kycPolicies}
        loyaltyPolicies={loyaltyPolicies}
        fireFetchData={this.fetchUserGroups}
      />
    });
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this user group ?'),
      buttons: [
        {
          color: 'primary',
          onClick: () => {
            this.deleteGroup(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
    },
    {
      Header: t('Kyc Policy'),
      accessor: 'attributes.kyc_id',
      Cell: props => <span>{this.state.kycPolicies && this.state.kycPolicies[props.value] ?
        this.state.kycPolicies[props.value].name : null}
      </span>,
    },
    {
      Header: t('Trade Fee Policy'),
      accessor: 'attributes.loyalty_id',
      Cell: props => <span>{this.state.loyaltyPolicies && this.state.loyaltyPolicies[props.value] ?
        this.state.loyaltyPolicies[props.value].name : null}
      </span>,
    },
    {
      Header: t('Actions'),
      accessor: 'id',
      width: 70,
      Cell: props => <div className='d-flex flex-row align-items-center justify-content-around'>
        <Rbac permission="update_user-groups">
          <ToolTip id={`edit_${props.value}`} text={t('Edit')}>
            <span
              className="text-one text-primary"
              onClick={this.state.kycPolicies && this.state.loyaltyPolicies ?
                () => {this.onPressEdit(props.original);} : null}
            >
              <i className="simple-icon-pencil edit-icon cursor-pointer"/>
            </span>
          </ToolTip>
        </Rbac>
        <Rbac permission="delete_user-groups">
          <ToolTip id={`delete_${props.value}`} text={t('Delete')}>
            <span className="text-one text-danger" onClick={() => {this.onPressDelete(props.value);}}>
              <i className="simple-icon-trash delete-icon cursor-pointer"/>
            </span>
          </ToolTip>
        </Rbac>
      </div>,
      show: Rbac.hasPermission('update_user-groups') || Rbac.hasPermission('delete_user-groups'),
    },
  ];

  render() {
    const {t, match} = this.props;
    const {groups, loading, kycPolicies, loyaltyPolicies} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Groups List')}
                  <Rbac permission='create_user-groups'>
                    <Button
                      onClick={this.onPressCreate}
                      disabled={!kycPolicies || !loyaltyPolicies}
                    >
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  onFetchData={this.fetchData}
                  data={groups}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns(t)}
                  pageSize={groups.length || 3}
                  style={{width: '100%'}}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
